<template>
    <div>
        <div name="btn-bar" class="simple-row">
            <div class="right">
                <a class="swb-btn swb-btn-small swb-btn-primary" @click="getDataList">刷新</a>
            </div>
        </div>
        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :height="tableHeight" :rowNoShow="rowNoShow" :btnColName="btnColName" :btnColTitle="btnColTitle"
                          :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :pageNoChangeHandler="pageNoChangeHandler" :onConfigReady="onConfigReady"></swb-result-table>
    </div>
</template>

<script>
    import {Utils, $} from '../../app.base'
    import {Vue, MsgBox, Routes, DomSizeWatcher} from '../../app.vues'

    import {getDefaultPageSizes} from '../../app.conf'

    import comnApi from '../../api/comn'
    import userApi from '../../api/user'


    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';

    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);

    export default {
        name: 'swb-asyn-task-info-list',
        props: ['params'],
        data: function () {
            return {
                confKey: "swb-asyn-task-info-list",
                queryOnLoad: true,

                tableHeight: 500,
                //
                needPager: true, //是否需要分页（默认：true）
                resultColConf: null,
                rowNoShow: false,
                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 100,//操作列宽度（默认：100）
                //
                btnColFixed: true, //操作列是否固定
                //
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),

                queryConfig: null,
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                taskPhaseMap: getEnumMap('taskPhase', 'value2text'),
                scopeEntity: {}
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            this.getCurrentUserInfo();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            //domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), null);
            //domSizeWatcher.setHrEls();

            //domSizeWatcher.start(500);
            //
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if (domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            getCurrentUserInfo: function () {
                let self = this;
                userApi.getUserInfoByContext({}, function (result, jqXhr) {
                    if (result.type == 'info') {
                        self.scopeEntity = result.data.scopeEntity;
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },
            onConfigReady(){
                this.getDataList();
            },
            initResultTable(){
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去
                resultTable.setQrySortRef(query_model_ctrl);
                // resultTable.setColConfRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'phaseStartTime': function (row, colName, colValue, rowIndex, colConf) {
                        if (row.phase == 3) {
                            return row.phaseStartTime;
                        } else {
                            return '';
                        }
                    },
                    'phase': function (row, colName, colValue, rowIndex, colConf) {
                        if (row.phase == 3) {
                            return row.state == 1 ? '执行成功' : '执行失败';
                        } else {
                            return self.taskPhaseMap[row.phase];
                        }
                    },
                    'jindu': function (row, colName, colValue, rowIndex, colConf) {
                        if (row.phase == 2 || row.phase == 3) {
                            if (Utils.isNoB(row.maxValue)) {
                                return '0%';
                            } else {
                                let curValue = row.curValue || 0;
                                return ((curValue / row.maxValue) * 100).toFixed(0) + '%';
                            }
                        } else {
                            return '';
                        }
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        let btnList = [];
                        if (row.creatorId == self.scopeEntity.staffId) {
                            if (row.phase == 0 || row.phase == 1) {
                                btnList.push({
                                    name: 'cancelled',
                                    text: '取消'
                                });
                            } else if (row.phase == -1 || row.state == -1) {
                                btnList.push({
                                    name: 'delete',
                                    text: '删除'
                                });
                            } else if (row.phase == 3 && row.state == 1) {
                                btnList.push({
                                    name: 'download',
                                    text: '下载'
                                });
                            }
                        }
                        return btnList;
                    }
                }, /* 单元格按钮点击处理函数 */{
                    'actions': function (row, colName, colValue, rowIndex, btnName, evnt) {
                        if (btnName == 'cancelled') {
                            self.doCancelled(row.id);
                        } else if (btnName == 'delete') {
                            self.doDelete(row.id);
                        } else if (btnName == 'download') {
                            self.doDownload(row);
                        }
                    }
                });
            },
            renderTable(rows, pagination) {
                //
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };

                resultTable.render(tableData);
            },
            handleSizeChange: function (val) {
                this.pageSize = val;
                this.handlePageChange(1);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getDataList();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getDataList();
            },
            getDataList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                if (!Utils.isNoB(self.params)) {
                    filterItems = Object.assign(filterItems, self.params);
                }
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let msgBoxDlg = MsgBox.loading();
                comnApi.getAsynTaskInfoList(postData, function (result) {
                    msgBoxDlg.close();
                    if (result.type == 'info') {
                        self.totalCount = result.data.pagination.totalCount;
                        let pagination = result.data.pagination;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                        //
                        self.renderTable(result.data.rows, pagination);
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.getDataList();
            },
            doCancelled(id){
                let self = this;
                self.$confirm('确定要取消吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let theLoad = MsgBox.loading();
                    comnApi.doAsynTaskInfoCancelled(id, function (result) {
                        theLoad.hide();
                        if (result.type == 'info') {
                            self.getDataList();
                        } else {
                            self.$message.warning(result.message);
                        }
                    });
                }).catch(function () {

                });
            },
            doDelete(id){
                let self = this;
                self.$confirm('确定要删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let theLoad = MsgBox.loading();
                    comnApi.deleteAsynTaskInfo(id, function (result) {
                        theLoad.hide();
                        if (result.type == 'info') {
                            self.getDataList();
                        } else {
                            self.$message.warning(result.message);
                        }
                    });
                }).catch(function () {

                });
            },
            doDownload(row){
                let extraData = row.extraData;
                if (Utils.isNoB(extraData)) {
                    MsgBox.warning('没有要下载的文件');
                    return;
                }
                let uuids = extraData.split('_');
                let length = uuids.length;
                for (let i = 0; i < length; i++) {
                    setTimeout(function () {
//                        Utils.downloadFile(getAppUrl("/file/download?uuid=" + uuids[i]));
                        Utils.setPageUrl(getAppUrl("/file/download?uuid=" + uuids[i]), '_blank');
                    }, 100 * i);
                }
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/comn/AsynTaskInfoList.vue